<div
	class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary c-portlet_box_specs pos-relative lift-chart-report"
	style="min-height: 27.5em"
>
	<app-loader [showLoader]="showLoad"></app-loader>
	<div>
		<div style="width: 100%; height: 100%" *ngIf="hasData">
			<div
				class="lift-chart"
				appTooltip
				title="Tooltip"
				[title]="campaignCarouselItem?.name"
				data-placement="top"
				data-size="small"
				[options]="tooltipOptions"
			>
				<div class="o-stack__cell lift-title">
					<h5 *ngIf="sectionclass != 'V6_preroll_lift_trend'">
						DISPLAY LIFT: {{ campaignCarouselItem?.name | uppercase }}
					</h5>
					<h5 *ngIf="sectionclass == 'V6_preroll_lift_trend'">
						{{ sectiontitle }} {{ campaignCarouselItem?.name | uppercase }}
					</h5>
				</div>

				<div
					class="o-stack__cell tinyGap u-font-small navigation_arrows"
					*ngIf="campaignsList.length > 1 && isR6Enabled"
				>
					<div class="left_arrow">
						<a href="javascript:void(null)">
							<img (click)="prevArrow()" src="../../../../../assets/images/left_arrow.svg" />
						</a>
					</div>
					<div class="right_arrow">
						<a href="javascript:void(null)">
							<img (click)="nextArrow()" src="../../../../../assets/images/right_arrow.svg" />
						</a>
					</div>
				</div>
			</div>
			<div class="date-range-banner" *ngIf="showDateRangeBanner">
				<div class="banner-content">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="14"
						height="14"
						viewBox="0 0 14 14"
						fill="none"
						style="margin-right: 8px; flex-shrink: 0"
					>
						<path
							d="M5.83333 7C5.83333 6.72386 6.05719 6.5 6.33333 6.5H7C7.27614 6.5 7.5 6.72386 7.5 7V10.3333C7.5 10.6095 7.27614 10.8333 7 10.8333C6.72386 10.8333 6.5 10.6095 6.5 10.3333V7.5H6.33333C6.05719 7.5 5.83333 7.27614 5.83333 7Z"
							fill="#00AAFF"
						/>
						<path
							d="M6.83267 3.83333C6.46583 3.83333 6.16497 4.13099 6.16667 4.50181C6.16765 4.86912 6.4658 5.16667 6.83333 5.16667C7.20148 5.16667 7.5 4.86814 7.5 4.5C7.5 4.13056 7.20017 3.83333 6.83267 3.83333Z"
							fill="#00AAFF"
						/>
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							d="M0.5 7C0.5 3.40986 3.40986 0.5 7 0.5C10.5901 0.5 13.5 3.40986 13.5 7C13.5 10.5901 10.5901 13.5 7 13.5C3.40986 13.5 0.5 10.5901 0.5 7ZM7 1.5C3.96214 1.5 1.5 3.96214 1.5 7C1.5 10.0379 3.96214 12.5 7 12.5C10.0379 12.5 12.5 10.0379 12.5 7C12.5 3.96214 10.0379 1.5 7 1.5Z"
							fill="#00AAFF"
						/>
					</svg>
					<div class="banner-text">
						Some lift values may be skewed due to historical data limits (only past 2 years + 1 quarter available)
					</div>
				</div>
			</div>
			<div>
				<div class="c-portlet__content u-pt-small" style="width: 100%" *ngIf="campaignCarouselItem">
					<div class="o-stack o-stack--center o-stact_ImgSpecs" style="height: auto">
						<div class="charts-container product-lift-chart-container" style="margin: 0 auto; width: 100%">
							<div class="chart-layout">
								<div [id]="'campaign' + i" class="individual-chart" style="min-height: 200px">
									<app-chart
										class="individual-chart"
										[setcolor]="setGraphBackgroundColor"
										[chartData]="campaignCarouselItem"
									></app-chart>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="no-data-container" *ngIf="!hasData">
			<div class="lift-chart">
				<div class="o-stack__cell">
					<h5 *ngIf="sectionclass != 'V6_preroll_lift_trend'">DISPLAY LIFT</h5>
					<h5 *ngIf="sectionclass == 'V6_preroll_lift_trend'">{{ sectiontitle }}</h5>
				</div>
			</div>
			<div class="map-no-data"><img [src]="placeholderimage" class="lift-trend-no-data-placeholder" /></div>
		</div>
	</div>
</div>
